!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ug = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ug",
    pluralRuleFunction: function (e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "يىل",
        relative: {
          0: "بۇ يىل",
          1: "كېلەر يىل",
          "-1": "ئۆتكەن يىل"
        },
        relativeTime: {
          future: {
            one: "{0} يىلدىن كېيىن",
            other: "{0} يىلدىن كېيىن"
          },
          past: {
            one: "{0} يىل ئىلگىرى",
            other: "{0} يىل ئىلگىرى"
          }
        }
      },
      "year-short": {
        displayName: "يىل",
        relative: {
          0: "بۇ يىل",
          1: "كېلەر يىل",
          "-1": "ئۆتكەن يىل"
        },
        relativeTime: {
          future: {
            one: "{0} يىلدىن كېيىن",
            other: "{0} يىلدىن كېيىن"
          },
          past: {
            one: "{0} يىل ئىلگىرى",
            other: "{0} يىل ئىلگىرى"
          }
        }
      },
      month: {
        displayName: "ئاي",
        relative: {
          0: "بۇ ئاي",
          1: "كېلەر ئاي",
          "-1": "ئۆتكەن ئاي"
        },
        relativeTime: {
          future: {
            one: "{0} ئايدىن كېيىن",
            other: "{0} ئايدىن كېيىن"
          },
          past: {
            one: "{0} ئاي ئىلگىرى",
            other: "{0} ئاي ئىلگىرى"
          }
        }
      },
      "month-short": {
        displayName: "ئاي",
        relative: {
          0: "بۇ ئاي",
          1: "كېلەر ئاي",
          "-1": "ئۆتكەن ئاي"
        },
        relativeTime: {
          future: {
            one: "{0} ئايدىن كېيىن",
            other: "{0} ئايدىن كېيىن"
          },
          past: {
            one: "{0} ئاي ئىلگىرى",
            other: "{0} ئاي ئىلگىرى"
          }
        }
      },
      day: {
        displayName: "كۈن",
        relative: {
          0: "بۈگۈن",
          1: "ئەتە",
          "-1": "تۈنۈگۈن"
        },
        relativeTime: {
          future: {
            one: "{0} كۈندىن كېيىن",
            other: "{0} كۈندىن كېيىن"
          },
          past: {
            one: "{0} كۈن ئىلگىرى",
            other: "{0} كۈن ئىلگىرى"
          }
        }
      },
      "day-short": {
        displayName: "كۈن",
        relative: {
          0: "بۈگۈن",
          1: "ئەتە",
          "-1": "تۈنۈگۈن"
        },
        relativeTime: {
          future: {
            one: "{0} كۈندىن كېيىن",
            other: "{0} كۈندىن كېيىن"
          },
          past: {
            one: "{0} كۈن ئىلگىرى",
            other: "{0} كۈن ئىلگىرى"
          }
        }
      },
      hour: {
        displayName: "سائەت",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            one: "{0} سائەتتىن كېيىن",
            other: "{0} سائەتتىن كېيىن"
          },
          past: {
            one: "{0} سائەت ئىلگىرى",
            other: "{0} سائەت ئىلگىرى"
          }
        }
      },
      "hour-short": {
        displayName: "سائەت",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            one: "{0} سائەتتىن كېيىن",
            other: "{0} سائەتتىن كېيىن"
          },
          past: {
            one: "{0} سائەت ئىلگىرى",
            other: "{0} سائەت ئىلگىرى"
          }
        }
      },
      minute: {
        displayName: "مىنۇت",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            one: "{0} مىنۇتتىن كېيىن",
            other: "{0} مىنۇتتىن كېيىن"
          },
          past: {
            one: "{0} مىنۇت ئىلگىرى",
            other: "{0} مىنۇت ئىلگىرى"
          }
        }
      },
      "minute-short": {
        displayName: "مىنۇت",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            one: "{0} مىنۇتتىن كېيىن",
            other: "{0} مىنۇتتىن كېيىن"
          },
          past: {
            one: "{0} مىنۇت ئىلگىرى",
            other: "{0} مىنۇت ئىلگىرى"
          }
        }
      },
      second: {
        displayName: "سېكۇنت",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            one: "{0} سېكۇنتتىن كېيىن",
            other: "{0} سېكۇنتتىن كېيىن"
          },
          past: {
            one: "{0} سېكۇنت ئىلگىرى",
            other: "{0} سېكۇنت ئىلگىرى"
          }
        }
      },
      "second-short": {
        displayName: "سېكۇنت",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            one: "{0} سېكۇنتتىن كېيىن",
            other: "{0} سېكۇنتتىن كېيىن"
          },
          past: {
            one: "{0} سېكۇنت ئىلگىرى",
            other: "{0} سېكۇنت ئىلگىرى"
          }
        }
      }
    }
  }];
});